<mat-form-field appearance="outline">
  <!-- chips list -->
  <mat-chip-grid
    #chipList
    [attr.aria-label]="configuration.placeholder"
    [required]="configuration.required"
    [disabled]="configuration.isDisabled"
  >
    <mat-chip-row *ngFor="let item of value" [selectable]="true" [removable]="true" (removed)="remove(item)">
      {{ item }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip-row>
    <!-- text input -->
    <input
      #chipsInput
      [placeholder]="configuration.placeholder"
      [formControl]="chipsInputCtrl"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="add($event)"
      [matAutocomplete]="auto"
    />
  </mat-chip-grid>
  <!-- auto complete input -->
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let option of filteredValues$ | async" [value]="option.key">
      {{ option.key }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
